module.exports = __webpack_public_path__ + "static/media/8.ea75a93a.png";